export function abbreviaStringa(address:any) {
    if (address && typeof address === 'string') {
      const lunghezza = address.length;
      if (lunghezza > 10) {
        return address.slice(0, 7) + '....' + address.slice(-7);
      } else {
        return address;
      }
    } else {
      return '';
    }
  }
